function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP title
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { dateOfBirth } from '../../actions/index';
import DateInput from '../date-input/DateInput';
import './DateOfBirth.scss';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
export class DateOfBirth extends React.Component {
  render() {
    const {
      dateOfBirth,
      setDateOfBirth
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(DateInput, {
        handleChange: setDateOfBirth,
        label: "Date of birth",
        maxFuture: moment().add(5, 'years'),
        name: "dateOfBirth",
        onBlur: setDateOfBirth,
        range: "past",
        section: "personal-details",
        values: {
          dateOfBirth
        }
      })
    });
  }
}
_defineProperty(DateOfBirth, "defaultProps", {
  dateOfBirth: {
    value: ''
  }
});
const mapStateToProps = ({
  dateOfBirth
}) => {
  return {
    dateOfBirth
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setDateOfBirth: value => {
      dispatch(dateOfBirth(value));
    }
  };
};
const VisibleDateOfBirth = connect(mapStateToProps, mapDispatchToProps)(DateOfBirth);
export default VisibleDateOfBirth;